import { useEffect } from 'react';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { SEO } from '@/components/seo/SEO';
import { useLanguage } from '@/context/LanguageContext';

const content = {
  nl: {
    title: 'Dienstbeschrijving',
    metaDescription: 'Dienstbeschrijving van Netblitz BV - Webontwikkeling en hosting services',
    sections: [
      {
        title: '1. Omschrijving van de dienst',
        content: [
          '1.1. Netblitz BV ("Dienstverlener"), onderdeel van de Tip Top Wash & Clean-groep, ontwikkelt en levert voor Opdrachtgever een maatwerk webapplicatie/website ("de Applicatie"), gebouwd met het Emergent-platform (emergent.sh).',
          '1.2. De Applicatie wordt toegankelijk gemaakt via een beveiligde webomgeving (URL) en één of meerdere gebruikerslogins voor Opdrachtgever en/of zijn medewerkers.',
          '1.3. Tenzij anders schriftelijk overeengekomen, wordt de Applicatie technisch gehost op het Emergent-platform onder het Emergent-account van Netblitz BV. Opdrachtgever krijgt geen directe toegang tot dit Emergent-account, maar wel tot de Applicatie zelf.'
        ]
      },
      {
        title: '2. Hosting en platform (Emergent)',
        content: [
          '2.1. De hosting van de Applicatie gebeurt via Emergent, een SaaS-platform van een derde partij. Netblitz BV is geen eigenaar van dit platform en heeft geen invloed op de algemene voorwaarden, prijswijzigingen of technische aanpassingen van Emergent.',
          '2.2. Netblitz BV zal zich inspannen om een passende hostingconfiguratie te kiezen in functie van het beoogde gebruik, maar kan geen garanties geven die verder gaan dan de beschikbaarheid en voorwaarden van Emergent zelf.',
          '2.3. Alle abonnementskosten en verbruikskosten die Emergent aan Netblitz BV aanrekent voor het hosten van de Applicatie voor Opdrachtgever, worden overeenkomstig de offerte of prijsafspraken aan Opdrachtgever doorgerekend (bijvoorbeeld via een maandelijkse hosting- of servicefee).',
          '2.4. Indien Emergent haar diensten stopzet, de voorwaarden ingrijpend wijzigt of langdurige storingen kent die buiten de invloedssfeer van Netblitz BV liggen, zal Netblitz BV in redelijkheid meedenken over alternatieven, maar is zij niet aansprakelijk voor de gevolgen hiervan voor Opdrachtgever.'
        ]
      },
      {
        title: '3. Gebruik, logins en data',
        content: [
          '3.1. Opdrachtgever ontvangt gebruikersaccounts (logins) om de Applicatie te gebruiken en is zelf verantwoordelijk voor zorgvuldig gebruik en beheer van inloggegevens en toegangsrechten.',
          '3.2. De (business-)data die Opdrachtgever in de Applicatie invoert, blijven eigendom van Opdrachtgever. Voor zover technisch mogelijk zal Netblitz BV op verzoek meewerken aan het exporteren van deze data in een gangbaar formaat (bijvoorbeeld CSV), tegen vergoeding op uurbasis, tenzij anders overeengekomen.',
          '3.3. Opdrachtgever staat ervoor in dat ingevoerde data en het gebruik van de Applicatie voldoen aan toepasselijke wetgeving (zoals GDPR) en geen inbreuk maken op rechten van derden.'
        ]
      },
      {
        title: '4. Onderhoud, support en wijzigingen',
        content: [
          '4.1. Tenzij anders afgesproken, verzorgt Netblitz BV technisch onderhoud en kleine updates aan de Applicatie binnen een vooraf overeengekomen urenbundel of supportpakket.',
          '4.2. Onder onderhoud wordt onder meer verstaan: het doorvoeren van noodzakelijke updates, aanpassingen als gevolg van wijzigingen in Emergent en het oplossen van bugs die niet zijn veroorzaakt door verkeerd gebruik door Opdrachtgever.',
          '4.3. Functionele uitbreidingen of wijzigingen op verzoek van Opdrachtgever (zoals nieuwe modules, integraties of rapportages) worden apart geoffreerd en uitgevoerd tegen het op dat moment geldende uurtarief, tenzij schriftelijk anders overeengekomen.',
          '4.4. Support-aanvragen verlopen via het door Netblitz BV opgegeven e-mailadres of supportkanaal. Eventuele reactie- en oplostijden zijn indicatief, tenzij in een aparte SLA uitdrukkelijk anders is vastgelegd.'
        ]
      },
      {
        title: '5. Beschikbaarheid en storingen',
        content: [
          '5.1. Netblitz BV streeft naar een hoge beschikbaarheid van de Applicatie, maar kan geen 100% uptime garanderen. Waar mogelijk sluit Netblitz BV aan bij de service levels die Emergent zelf hanteert.',
          '5.2. Bij storingen of performanceproblemen zal Netblitz BV zich inspannen om de oorzaak te achterhalen en, waar mogelijk, in samenwerking met Emergent te verhelpen.',
          '5.3. Onderbrekingen of storingen die (mede) veroorzaakt worden door Emergent of andere derde partijen, internetproviders, DNS-providers of door foutief gebruik door Opdrachtgever, vallen buiten de aansprakelijkheid van Netblitz BV.'
        ]
      },
      {
        title: '6. Overdracht naar eigen account of andere hosting',
        content: [
          '6.1. Opdrachtgever kan verzoeken om de Applicatie (voor zover technisch mogelijk) over te zetten naar een eigen Emergent-account of andere hostingomgeving.',
          '6.2. Een dergelijke migratie valt buiten de standaard dienstverlening. Netblitz BV zal hieraan meewerken op basis van nacalculatie aan het op dat moment geldende uurtarief, plus eventuele bijkomende kosten van Emergent of andere derde partijen.',
          '6.3. Netblitz BV kan bij migratie niet garanderen dat alle functionaliteiten 1-op-1 identiek beschikbaar zijn in de nieuwe omgeving, noch dat geen downtime optreedt tijdens de overdracht. Dit wordt vooraf zo goed mogelijk ingeschat en met Opdrachtgever afgestemd.',
          '6.4. Na succesvolle migratie en betaling van alle openstaande facturen behoudt Opdrachtgever de overeengekomen gebruiksrechten op de Applicatie. Eventuele licenties of componenten van derden kunnen aanvullende voorwaarden hebben.'
        ]
      },
      {
        title: '7. Beëindiging van de dienstverlening',
        content: [
          '7.1. Bij beëindiging van de samenwerking of stopzetting van de hosting via Netblitz BV zal, indien Opdrachtgever dit tijdig verzoekt, in redelijkheid worden meegewerkt aan het exporteren van data en/of migratie zoals omschreven in artikel 6.',
          '7.2. Beëindiging ontslaat Opdrachtgever niet van de verplichting openstaande facturen voor ontwikkelwerk, hosting en support te voldoen.',
          '7.3. Indien Opdrachtgever na beëindiging geen actie onderneemt om zijn data veilig te stellen, kan Netblitz BV niet verantwoordelijk worden gehouden voor verlies van data na het verstrijken van een redelijke bewaartermijn.'
        ]
      }
    ]
  },
  en: {
    title: 'Service Description',
    metaDescription: 'Service Description of Netblitz BV - Web development and hosting services',
    sections: [
      {
        title: '1. Description of the Service',
        content: [
          '1.1. Netblitz BV ("Service Provider"), part of the Tip Top Wash & Clean group, develops and delivers a custom web application/website ("the Application") for the Client, built with the Emergent platform (emergent.sh).',
          '1.2. The Application is made accessible via a secure web environment (URL) and one or more user logins for the Client and/or their employees.',
          '1.3. Unless otherwise agreed in writing, the Application is technically hosted on the Emergent platform under Netblitz BV\'s Emergent account. The Client does not receive direct access to this Emergent account, but does have access to the Application itself.'
        ]
      },
      {
        title: '2. Hosting and Platform (Emergent)',
        content: [
          '2.1. The hosting of the Application is done via Emergent, a SaaS platform from a third party. Netblitz BV does not own this platform and has no influence on the general terms, price changes, or technical modifications of Emergent.',
          '2.2. Netblitz BV will endeavor to choose a suitable hosting configuration based on the intended use, but cannot provide guarantees beyond the availability and terms of Emergent itself.',
          '2.3. All subscription costs and usage costs that Emergent charges Netblitz BV for hosting the Application for the Client are passed on to the Client in accordance with the quote or price agreements (e.g., via a monthly hosting or service fee).',
          '2.4. If Emergent discontinues its services, significantly changes its terms, or experiences prolonged outages beyond Netblitz BV\'s control, Netblitz BV will reasonably consider alternatives but is not liable for the consequences for the Client.'
        ]
      },
      {
        title: '3. Use, Logins and Data',
        content: [
          '3.1. The Client receives user accounts (logins) to use the Application and is responsible for careful use and management of login credentials and access rights.',
          '3.2. The (business) data that the Client enters into the Application remains the property of the Client. Where technically possible, Netblitz BV will cooperate on request to export this data in a common format (e.g., CSV), for an hourly fee, unless otherwise agreed.',
          '3.3. The Client guarantees that entered data and use of the Application comply with applicable legislation (such as GDPR) and do not infringe on the rights of third parties.'
        ]
      },
      {
        title: '4. Maintenance, Support and Changes',
        content: [
          '4.1. Unless otherwise agreed, Netblitz BV provides technical maintenance and minor updates to the Application within a pre-agreed hour bundle or support package.',
          '4.2. Maintenance includes: implementing necessary updates, modifications resulting from changes in Emergent, and fixing bugs not caused by incorrect use by the Client.',
          '4.3. Functional extensions or changes at the Client\'s request (such as new modules, integrations, or reports) are quoted separately and executed at the current hourly rate, unless otherwise agreed in writing.',
          '4.4. Support requests are handled via the email address or support channel specified by Netblitz BV. Any response and resolution times are indicative, unless explicitly stated otherwise in a separate SLA.'
        ]
      },
      {
        title: '5. Availability and Disruptions',
        content: [
          '5.1. Netblitz BV strives for high availability of the Application but cannot guarantee 100% uptime. Where possible, Netblitz BV aligns with the service levels that Emergent itself maintains.',
          '5.2. In case of disruptions or performance issues, Netblitz BV will endeavor to identify the cause and, where possible, resolve it in cooperation with Emergent.',
          '5.3. Interruptions or disruptions caused (in part) by Emergent or other third parties, internet providers, DNS providers, or by incorrect use by the Client, fall outside the liability of Netblitz BV.'
        ]
      },
      {
        title: '6. Transfer to Own Account or Other Hosting',
        content: [
          '6.1. The Client may request to transfer the Application (where technically possible) to their own Emergent account or other hosting environment.',
          '6.2. Such migration falls outside the standard services. Netblitz BV will cooperate on a time and materials basis at the current hourly rate, plus any additional costs from Emergent or other third parties.',
          '6.3. Netblitz BV cannot guarantee that all functionalities will be identically available in the new environment, nor that no downtime will occur during the transfer. This will be estimated as accurately as possible and coordinated with the Client in advance.',
          '6.4. After successful migration and payment of all outstanding invoices, the Client retains the agreed usage rights to the Application. Any licenses or third-party components may have additional terms.'
        ]
      },
      {
        title: '7. Termination of Services',
        content: [
          '7.1. Upon termination of the cooperation or cessation of hosting via Netblitz BV, if the Client requests it in a timely manner, reasonable cooperation will be provided for exporting data and/or migration as described in article 6.',
          '7.2. Termination does not release the Client from the obligation to pay outstanding invoices for development work, hosting, and support.',
          '7.3. If the Client takes no action to secure their data after termination, Netblitz BV cannot be held responsible for loss of data after a reasonable retention period has expired.'
        ]
      }
    ]
  },
  fr: {
    title: 'Description du Service',
    metaDescription: 'Description du service de Netblitz BV - Services de développement web et hébergement',
    sections: [
      {
        title: '1. Description du service',
        content: [
          '1.1. Netblitz BV ("Prestataire de services"), faisant partie du groupe Tip Top Wash & Clean, développe et fournit au Client une application web/site web sur mesure ("l\'Application"), construite avec la plateforme Emergent (emergent.sh).',
          '1.2. L\'Application est rendue accessible via un environnement web sécurisé (URL) et un ou plusieurs identifiants utilisateur pour le Client et/ou ses employés.',
          '1.3. Sauf accord écrit contraire, l\'Application est techniquement hébergée sur la plateforme Emergent sous le compte Emergent de Netblitz BV. Le Client n\'a pas d\'accès direct à ce compte Emergent, mais a accès à l\'Application elle-même.'
        ]
      },
      {
        title: '2. Hébergement et plateforme (Emergent)',
        content: [
          '2.1. L\'hébergement de l\'Application se fait via Emergent, une plateforme SaaS d\'un tiers. Netblitz BV n\'est pas propriétaire de cette plateforme et n\'a aucune influence sur les conditions générales, les modifications de prix ou les ajustements techniques d\'Emergent.',
          '2.2. Netblitz BV s\'efforcera de choisir une configuration d\'hébergement adaptée à l\'utilisation prévue, mais ne peut fournir de garanties au-delà de la disponibilité et des conditions d\'Emergent.',
          '2.3. Tous les coûts d\'abonnement et de consommation qu\'Emergent facture à Netblitz BV pour l\'hébergement de l\'Application du Client sont répercutés au Client conformément au devis ou aux accords de prix.',
          '2.4. Si Emergent cesse ses services, modifie considérablement ses conditions ou connaît des pannes prolongées hors du contrôle de Netblitz BV, Netblitz BV réfléchira raisonnablement aux alternatives mais n\'est pas responsable des conséquences pour le Client.'
        ]
      },
      {
        title: '3. Utilisation, identifiants et données',
        content: [
          '3.1. Le Client reçoit des comptes utilisateur (identifiants) pour utiliser l\'Application et est responsable de l\'utilisation et de la gestion soigneuses des identifiants de connexion et des droits d\'accès.',
          '3.2. Les données (métier) que le Client saisit dans l\'Application restent la propriété du Client. Dans la mesure du possible techniquement, Netblitz BV coopérera sur demande pour exporter ces données dans un format courant (par exemple CSV), contre rémunération horaire.',
          '3.3. Le Client garantit que les données saisies et l\'utilisation de l\'Application sont conformes à la législation applicable (comme le RGPD) et ne portent pas atteinte aux droits de tiers.'
        ]
      },
      {
        title: '4. Maintenance, support et modifications',
        content: [
          '4.1. Sauf accord contraire, Netblitz BV assure la maintenance technique et les mises à jour mineures de l\'Application dans le cadre d\'un forfait d\'heures ou d\'un package de support préalablement convenu.',
          '4.2. La maintenance comprend notamment : la mise en œuvre des mises à jour nécessaires, les ajustements suite aux modifications d\'Emergent et la correction des bugs non causés par une mauvaise utilisation du Client.',
          '4.3. Les extensions fonctionnelles ou modifications à la demande du Client sont proposées séparément et exécutées au tarif horaire en vigueur.',
          '4.4. Les demandes de support sont traitées via l\'adresse e-mail ou le canal de support spécifié par Netblitz BV. Les délais de réponse et de résolution sont indicatifs.'
        ]
      },
      {
        title: '5. Disponibilité et pannes',
        content: [
          '5.1. Netblitz BV s\'efforce d\'assurer une haute disponibilité de l\'Application mais ne peut garantir 100% de temps de fonctionnement.',
          '5.2. En cas de pannes ou de problèmes de performance, Netblitz BV s\'efforcera d\'identifier la cause et de la résoudre en coopération avec Emergent.',
          '5.3. Les interruptions ou pannes causées par Emergent, d\'autres tiers, des fournisseurs d\'accès Internet ou par une mauvaise utilisation du Client ne relèvent pas de la responsabilité de Netblitz BV.'
        ]
      },
      {
        title: '6. Transfert vers un compte propre ou autre hébergement',
        content: [
          '6.1. Le Client peut demander le transfert de l\'Application vers son propre compte Emergent ou un autre environnement d\'hébergement.',
          '6.2. Une telle migration ne fait pas partie des services standard. Netblitz BV y coopérera sur base horaire au tarif en vigueur.',
          '6.3. Netblitz BV ne peut garantir que toutes les fonctionnalités seront identiquement disponibles dans le nouvel environnement.',
          '6.4. Après une migration réussie et le paiement de toutes les factures en suspens, le Client conserve les droits d\'utilisation convenus sur l\'Application.'
        ]
      },
      {
        title: '7. Fin des services',
        content: [
          '7.1. À la fin de la collaboration, une coopération raisonnable sera fournie pour l\'exportation des données si le Client le demande en temps voulu.',
          '7.2. La résiliation ne libère pas le Client de l\'obligation de payer les factures en suspens.',
          '7.3. Si le Client ne prend aucune mesure pour sécuriser ses données après la résiliation, Netblitz BV ne peut être tenu responsable de la perte de données.'
        ]
      }
    ]
  },
  de: {
    title: 'Dienstbeschreibung',
    metaDescription: 'Dienstbeschreibung von Netblitz BV - Webentwicklung und Hosting-Services',
    sections: [
      {
        title: '1. Beschreibung der Dienstleistung',
        content: [
          '1.1. Netblitz BV ("Dienstleister"), Teil der Tip Top Wash & Clean-Gruppe, entwickelt und liefert für den Auftraggeber eine maßgeschneiderte Webanwendung/Website ("die Anwendung"), die mit der Emergent-Plattform (emergent.sh) erstellt wurde.',
          '1.2. Die Anwendung wird über eine sichere Webumgebung (URL) und einen oder mehrere Benutzer-Logins für den Auftraggeber und/oder seine Mitarbeiter zugänglich gemacht.',
          '1.3. Sofern nicht anders schriftlich vereinbart, wird die Anwendung technisch auf der Emergent-Plattform unter dem Emergent-Konto von Netblitz BV gehostet.'
        ]
      },
      {
        title: '2. Hosting und Plattform (Emergent)',
        content: [
          '2.1. Das Hosting der Anwendung erfolgt über Emergent, eine SaaS-Plattform eines Drittanbieters. Netblitz BV ist nicht Eigentümer dieser Plattform.',
          '2.2. Netblitz BV wird sich bemühen, eine geeignete Hosting-Konfiguration basierend auf der beabsichtigten Nutzung zu wählen.',
          '2.3. Alle Abonnement- und Verbrauchskosten, die Emergent Netblitz BV für das Hosting berechnet, werden dem Auftraggeber weitergegeben.',
          '2.4. Falls Emergent seine Dienste einstellt, ist Netblitz BV nicht für die Folgen für den Auftraggeber haftbar.'
        ]
      },
      {
        title: '3. Nutzung, Logins und Daten',
        content: [
          '3.1. Der Auftraggeber erhält Benutzerkonten (Logins) zur Nutzung der Anwendung.',
          '3.2. Die (Geschäfts-)Daten, die der Auftraggeber in die Anwendung eingibt, bleiben Eigentum des Auftraggebers.',
          '3.3. Der Auftraggeber garantiert, dass eingegebene Daten und die Nutzung der Anwendung der geltenden Gesetzgebung entsprechen.'
        ]
      },
      {
        title: '4. Wartung, Support und Änderungen',
        content: [
          '4.1. Sofern nicht anders vereinbart, übernimmt Netblitz BV technische Wartung und kleine Updates.',
          '4.2. Wartung umfasst: notwendige Updates, Anpassungen aufgrund von Änderungen in Emergent und Fehlerbehebung.',
          '4.3. Funktionelle Erweiterungen werden separat angeboten und zum aktuellen Stundensatz ausgeführt.',
          '4.4. Support-Anfragen werden über die von Netblitz BV angegebene E-Mail-Adresse bearbeitet.'
        ]
      },
      {
        title: '5. Verfügbarkeit und Störungen',
        content: [
          '5.1. Netblitz BV strebt eine hohe Verfügbarkeit der Anwendung an, kann aber keine 100% Verfügbarkeit garantieren.',
          '5.2. Bei Störungen wird Netblitz BV sich bemühen, die Ursache zu ermitteln und in Zusammenarbeit mit Emergent zu beheben.',
          '5.3. Unterbrechungen durch Emergent oder andere Dritte fallen nicht in die Haftung von Netblitz BV.'
        ]
      },
      {
        title: '6. Übertragung auf eigenes Konto oder anderes Hosting',
        content: [
          '6.1. Der Auftraggeber kann die Übertragung der Anwendung auf sein eigenes Emergent-Konto anfordern.',
          '6.2. Eine solche Migration fällt nicht unter die Standardleistungen.',
          '6.3. Netblitz BV kann nicht garantieren, dass alle Funktionen identisch verfügbar sein werden.',
          '6.4. Nach erfolgreicher Migration behält der Auftraggeber die vereinbarten Nutzungsrechte.'
        ]
      },
      {
        title: '7. Beendigung der Dienstleistungen',
        content: [
          '7.1. Bei Beendigung der Zusammenarbeit wird auf Anfrage Unterstützung beim Datenexport geleistet.',
          '7.2. Die Beendigung entbindet den Auftraggeber nicht von der Pflicht, ausstehende Rechnungen zu begleichen.',
          '7.3. Wenn der Auftraggeber nach Beendigung keine Maßnahmen zur Datensicherung ergreift, kann Netblitz BV nicht für Datenverlust verantwortlich gemacht werden.'
        ]
      }
    ]
  }
};

const ServiceDescriptionPage = () => {
  const { language } = useLanguage();
  const t = content[language] || content.nl;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO 
        title={t.title}
        description={t.metaDescription}
      />
      <Navbar />
      <main className="min-h-screen bg-white pt-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16">
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-8">{t.title}</h1>
          
          <div className="prose prose-slate max-w-none">
            {t.sections.map((section, index) => (
              <div key={index} className="mb-10">
                <h2 className="text-xl font-bold text-slate-900 mb-4">{section.title}</h2>
                {section.content.map((paragraph, pIndex) => (
                  <p key={pIndex} className="text-slate-600 mb-3 leading-relaxed">
                    {paragraph}
                  </p>
                ))}
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-slate-200">
            <p className="text-sm text-slate-500">
              Netblitz BV - {language === 'nl' ? 'Onderdeel van Tip Top Wash & Clean-groep' : language === 'en' ? 'Part of Tip Top Wash & Clean group' : language === 'fr' ? 'Partie du groupe Tip Top Wash & Clean' : 'Teil der Tip Top Wash & Clean-Gruppe'}
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ServiceDescriptionPage;
